import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../../services/api";
import { API_URL } from "@/constants";
import type { MediaProjectListItem } from "../../types";

type ProjectsPageResponse = { items: MediaProjectListItem[] };

/**
 * The project's thumbnail, as the projects list shows it: undefined while
 * loading, null when the project has none or the request fails.
 */
export function useProjectThumbnail(
  organizationId: string | undefined,
  projectId: string | undefined
): { thumbnail: string | null | undefined } {
  const query = useQuery({
    queryKey: ["project-thumbnail", organizationId, projectId],
    queryFn: async ({ signal }) => {
      // Only the list endpoint returns the thumbnail.
      const { data } = await axiosInstance.get<ProjectsPageResponse>(
        `${API_URL}/media/${organizationId}/projects`,
        { params: new URLSearchParams({ ids: projectId ?? "" }), signal }
      );
      return data.items[0]?.thumbnail_url ?? null;
    },
    enabled: !!organizationId && !!projectId,
    staleTime: 1000 * 60 * 5,
  });
  return { thumbnail: query.isError ? null : query.data };
}
